import React, { Component } from 'react';
import Flag from '../Flag';
import PropTypes from 'prop-types';
import {
  ListContainer,
  CountryName,
  CurrencyName,
  LabelContainer,
} from '../Styled';

const FiatCurrencySelectorOption = props => {
  const handleMouseDown = event => {
    event.preventDefault();
    event.stopPropagation();
    props.onSelect(props.option, event);
  };

  const handleMouseEnter = event => {
    props.onFocus(props.option, event);
  };

  const handleMouseMove = event => {
    if (props.isFocused) {
      return;
    }
    props.onFocus(props.option, event);
  };

  return (
    <ListContainer
      className={props.className}
      onMouseDown={handleMouseDown}
      onMouseEnter={handleMouseEnter}
      onMouseMove={handleMouseMove}
      title={props.option.label}
    >
      <Flag currency={props.option.value} />
      <LabelContainer>
        <CurrencyName>{props.option.value}</CurrencyName>
        <CountryName>{props.option.label}</CountryName>
      </LabelContainer>
    </ListContainer>
  );
};

FiatCurrencySelectorOption.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  isFocused: PropTypes.bool,
  isSelected: PropTypes.bool,
  onFocus: PropTypes.func,
  onSelect: PropTypes.func,
  option: PropTypes.object.isRequired,
};

export default FiatCurrencySelectorOption;
